<idp-book-widget-search-modal-mach-core
  [recentSearchList]="recentSearchList"
  [savedSearchList]="savedSearchList"
  [searchModalTabs]="searchModalTabs"
  [predictiveSearchData]="predictiveSearchData"
  [isFullscreen]="isFullscreen"
  [modalOpen]="modalOpen"
  (searchModalClose)="handleSearchModalClose($event)"
  (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
  (searchStringChanged)="
    handleModalEvents({ type: 'searchStringChanged', data: $event })
  "
  (savedSearchItemSelected)="
    handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
  "
  (recentSearchItemSelected)="
    handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
  "
  (predictiveSearchItemSelected)="handlePredictiveSearchItemselection($event)"
>
  <div
    [id]="elementId"
    class="airport-code h-full"
    [idpErrorState]="!!(routePickerError?.[routeIndex]?.origin || routePickerError?.[routeIndex]?.destination || routePickerError?.[routeIndex]?.sameRoute)"
  ></div>
</idp-book-widget-search-modal-mach-core>
